import { render, staticRenderFns } from "./PlatformFeeDistributionItem.vue?vue&type=template&id=1e03faa8&scoped=true&"
import script from "./PlatformFeeDistributionItem.vue?vue&type=script&lang=js&"
export * from "./PlatformFeeDistributionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e03faa8",
  null
  
)

export default component.exports